import {
  Box,
  Breadcrumbs,
  Button,
  Checkbox,
  Container,
  Divider,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
  colors,
} from '@mui/material';
import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { fetchWith401Check } from '../../helpers/http';

const API_URL = process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_API_HOST : process.env.REACT_APP_API_HOST_PROD;

const RegisterPageV2 = () => {
  const [form, setForm] = React.useState({});
  const [isAccept, setIsAccept] = React.useState(false);

  const [captcha, setCaptcha] = React.useState();

  const [loadingState, setLoadingState] = React.useState({});

  const orgs = [
    {
      id: 'escap',
      label: 'ESCAP',
    },
    {
      id: 'fao',
      label: 'FAO',
    },
    {
      id: 'ifad',
      label: 'IFAD',
    },
    {
      id: 'ilo',
      label: 'ILO',
    },
    {
      id: 'imf',
      label: 'IMF',
    },
    {
      id: 'iom',
      label: 'IOM',
    },

    {
      id: 'itu',
      label: 'ITU',
    },
    {
      id: 'unocha',
      label: 'OCHA',
    },
    {
      id: 'ohchr',
      label: 'OHCHR',
    },
    {
      id: 'plj',
      label: 'UN Global Pulse Asia Pacific Hub',
    },
    {
      id: 'rco',
      label: 'RCO (UN in Indonesia)',
    },
    {
      id: 'un_habitat',
      label: 'UN HABITAT',
    },
    {
      id: 'un_women',
      label: 'OCHA',
    },
    {
      id: 'unaids',
      label: 'UN WOMEN',
    },
    {
      id: 'undp',
      label: 'UNDP',
    },
    {
      id: 'unep',
      label: 'UNEP',
    },

    {
      id: 'unesco',
      label: 'UNESCO',
    },
    {
      id: 'unfpa',
      label: 'UNFPA',
    },
    {
      id: 'unhcr',
      label: 'UNHCR',
    },
    {
      id: 'unicef',
      label: 'UNICEF',
    },
    {
      id: 'unido',
      label: 'UNIDO',
    },
    {
      id: 'unodc',
      label: 'UNODC',
    },
    {
      id: 'unops',
      label: 'UNOPS',
    },
    {
      id: 'wfp',
      label: 'WFP',
    },
    {
      id: 'who',
      label: 'WHO',
    },
    {
      id: 'wb',
      label: 'World Bank',
    },
  ];

  const navigate = useNavigate();

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return emailRegex.test(email);
  };

  const doRegister = () => {
    if (!validateEmail(form.email_address)) return alert('Please fix email format, ex: contoso@microsoft.con');
    if (!form.first_name) return alert('Please fill first name');
    if (!form.last_name) return alert('Please fill last name');
    if (!form.position) return alert('Please fill position');
    if (!form.phone) return alert('Please fill phone number');
    if (!form.email_address) return alert('Please fill email address');
    if (!form.password) return alert('Please fill password');
    if (!form.confirm_password) return alert('Please fill confirm password');
    if (!form.organization) return alert('Please choose organization');

    if (form.password !== form.confirm_password) return alert('Password and confirm password are not matched');
    if (form.password.length < 12) return alert('Minimum password length is 12 characters');

    setLoadingState({ ...loadingState, submit: true });

    try {
      const body = { ...form, captcha_token: captcha };

      fetchWith401Check(`${API_URL}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((result) => {
          toast.success('Registration succeess, waiting for verification.');
          setLoadingState({ ...loadingState, submit: false });
          setTimeout(() => {
            navigate('/register/success');
          }, 1000);
        })
        .catch((error) => {
          console.log(error);
          toast.error(error.message);
          setLoadingState({ ...loadingState, submit: false });
        });
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <Stack sx={{ backgroundColor: colors.cyan[50] }}>
      <Container maxWidth='xs' sx={{ minHeight: '100vh', backgroundColor: colors.common.white }}>
        <Breadcrumbs aria-label='breadcrumb' p={2}>
          <Link underline='hover' color='inherit' href='/auth'>
            Auth
          </Link>
          <Typography color='text.primary'>Registration</Typography>
        </Breadcrumbs>

        <Divider />

        <Stack direction='column' spacing={1} mt={2} alignItems='center'>
          <Stack spacing={1}>
            <Typography sx={{ fontWeight: 'bold' }}>Register</Typography>
            <Box sx={{ m: 4 }}></Box>
            <Stack direction='row' spacing={1}>
              <TextField required label='First Name' onChange={(e) => setForm({ ...form, first_name: e.currentTarget.value })} value={form.first_name} />
              <TextField required label='Last Name' onChange={(e) => setForm({ ...form, last_name: e.currentTarget.value })} value={form.last_name} />
            </Stack>
            <Stack direction='column' spacing={1}>
              <TextField required label='Position' value={form.position} onChange={(e) => setForm({ ...form, position: e.currentTarget.value })} />
              <TextField required label='Phone Number' value={form.phone} onChange={(e) => setForm({ ...form, phone: e.currentTarget.value })} />
              <TextField
                required
                type='email'
                label='Email Address'
                value={form.email_address}
                onChange={(e) => setForm({ ...form, email_address: e.currentTarget.value })}
              />
              <TextField required label='Password' value={form.password} onChange={(e) => setForm({ ...form, password: e.currentTarget.value })} />
              <TextField
                required
                label='Confirm Password'
                value={form.confirm_password}
                onChange={(e) => setForm({ ...form, confirm_password: e.currentTarget.value })}
              />
              <FormControl fullWidth>
                <InputLabel required id='org'>
                  Organizations
                </InputLabel>
                <Select
                  labelId='org'
                  id='org'
                  value={form.organization}
                  label='Organization'
                  onChange={(e) => setForm({ ...form, organization: e.target.value })}
                >
                  {orgs.map((item) => (
                    <MenuItem value={item.id} key={item.id}>
                      {item.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
            <Stack direction='row' alignItems='center'>
              <Checkbox onChange={() => setIsAccept(!isAccept)} />
              <Typography variant='body2'>I accept the terms and condition</Typography>
            </Stack>

            <Stack direction='column' spacing={1}>
              <Button disabled={!isAccept || !captcha || loadingState.submit} onClick={() => doRegister()} variant='contained'>
                Sign Up
              </Button>
              <Typography onClick={() => navigate('/auth')} variant='body2' sx={{ color: colors.blue[800], cursor: 'pointer' }}>
                Already have account? Sign in
              </Typography>
            </Stack>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_STAGE === 'DEVELOPMENT' ? process.env.REACT_APP_SITE_KEY_DEV : process.env.REACT_APP_SITE_KEY}
              onChange={(value) => setCaptcha(value)}
            />
          </Stack>
        </Stack>
      </Container>
    </Stack>
  );
};

export default RegisterPageV2;
